import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import KanbanRoute from "./KanbanRoute";

// const KanbanRouteWithProvider = React.lazy(() => import("./KanbanRoute"));

export const KnabanRouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <KanbanRoute />
    </Suspense>
  );
};
